import {Component} from "react";
import {
    Button,
    Card,
    Col, DropdownButton,
    Dropdown,
    Form,
    Row
} from "react-bootstrap";
import {UpdateUserPasswordToken} from "../../api/Secuirty/UpdatedUserPasswordToken";
import {toast} from "react-toastify";

export interface RequestPhonePinProps{
    requestedPhone?: ()=> void;
    resend?: boolean
    skinny?: boolean
    userName?: string
}
interface RequestPhonePinState{
    requestingPhone: boolean
    requestText: boolean
}
export default class RequestPhonePin extends Component<RequestPhonePinProps, RequestPhonePinState> {

    state: RequestPhonePinState ={
        requestingPhone: false,
        requestText: true
    }

    requestNewPhonePin = () => {
        if(this.state.requestingPhone){
            this.requestNewPhonePinVoice();
        }else{
            this.requestNewPhonePinText();
        }
    }
    requestNewPhonePinVoice = () => {
        UpdateUserPasswordToken('RequestVoicePin',this.props.userName || '', '', () => {}).then(()=> {});
        toast.success("Pin Requested.")
        if(this.props.requestedPhone) {
            this.props.requestedPhone();
        }
    }
    requestNewPhonePinText = () => {
        UpdateUserPasswordToken('RequestTextPin',this.props.userName|| '', '', () => {}).then(()=> {});
        toast.success("Pin Requested.")
        if(this.props.requestedPhone) {
            this.props.requestedPhone();
        }
    }

    render() {
        return <>{this.props.skinny ?
            <>
                <DropdownButton id="dropdown-new-pin-button" title="Request New Pin">
                    <Dropdown.Item onClick={()=>{this.requestNewPhonePinText()}}>{this.props.resend ? "Resend Pin As Text": "Send Pin As Text" }</Dropdown.Item>
                    <Dropdown.Item onClick={()=>{this.requestNewPhonePinVoice()}}>{this.props.resend ? "Resend Pin As Voice": "Send Pin As Voice" }</Dropdown.Item>
                </DropdownButton>
            </>
            : <>
                <Row>
                    <Col md={{span: 6, offset: 3}}>
                        <Card>
                            <Card.Header className="text-center">
                                {this.props.resend ? "Resend Pin" : "Change Password One Time Pin Communication"}
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col md={{span: 2, offset: 4}}>
                                        <Form.Check onChange={(e)=> {this.setState({requestingPhone: e.target.checked})}}
                                                    name="pin-request-type"
                                                    value='voice' type='radio'
                                                    id='voice-pin-request'
                                                    label='Voice Call Pin'/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={{span: 2, offset: 4}}>
                                        <Form.Check onChange={(e)=> {this.setState({requestingPhone: e.target.checked})}}
                                                    defaultChecked={true}
                                                    name="pin-request-type"
                                                    value='text' type='radio'
                                                    id='text-pin-request'
                                                    label='Text Pin'/>
                                    </Col>
                                </Row>
                            </Card.Body>
                            <Card.Footer>
                                <Button onClick={(e) => {
                                    e.preventDefault();
                                    this.requestNewPhonePin();
                                }} block={true} variant='primary'>
                                    Send Pin
                                </Button>
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </>
        }
        </>
    }
}
